import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { ThemeProvider } from "./components/theme/ThemeProvider";
import "@fontsource-variable/inter/index.css";
import "@fontsource-variable/fraunces/index.css";
import "./index.css";

const rootElement = document.getElementById("root")!;

const AppTree = (
  <HelmetProvider>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </HelmetProvider>
);

// react-snap pré-renderiza cada rota em HTML estático dentro de /dist.
// Se o HTML já tem conteúdo (foi pré-renderizado), hidratamos; senão, montamos.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, AppTree);
} else {
  createRoot(rootElement).render(AppTree);
}
